/**
 * Import Dependency
 */
import React from 'react'

/**
 * Declare Variable
 */
const Toast = (props) => {
  return (
    <React.Fragment />
  )
}

/**
 * Export
 */
export default Toast



// WEBPACK FOOTER //
// ./src/components/Toast.js